import type { ApiFormAnswer, ApiFormQuestion } from 'src/core/models/api/shared/ApiFormQuestion';

/**
 * The key an answer is stored under, which is not always the question name.
 */
export function answerKey(question: ApiFormQuestion): string {
	return question.name.replace(/[^a-zA-Z0-9]+/g, '-');
}

/**
 * Which programme part each choice answer points at, by its own id rather than by its title. Two parts of a
 * programme may carry the same title, so a title is not an identity (#404).
 */
export function choiceReferences(
	questions: ApiFormQuestion[],
	answers: Record<string, ApiFormAnswer>,
): Record<string, string[]> {
	const references: Record<string, string[]> = {};

	questions.forEach((question) => {
		const options = question.options ?? [];

		if (!options.some((option) => option.value)) return;

		const answer = answers[answerKey(question)] ?? answers[question.name];
		const picked = Array.isArray(answer) ? answer : answer === null || answer === undefined ? [] : [String(answer)];

		const values = options
			.filter((option) => option.value && picked.includes(option.name))
			.map((option) => option.value as string);

		if (values.length > 0) references[question.name] = values;
	});

	return references;
}
